import AuctionHousesList from "./AuctionHousesList";

export default AuctionHousesList;
